const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
const CUID_PATTERN = /^c[a-z0-9]{20,}$/i

export function isValidWorkspaceId(value: unknown): value is string {
  return typeof value === 'string'
    && (UUID_PATTERN.test(value) || CUID_PATTERN.test(value))
}
